var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.852 4.25H15.4261C19.8822 4.25 23.6175 7.37468 24.6113 11.5781C24.7808 12.2949 24.8705 13.0431 24.8705 13.8125C24.8705 19.0937 20.6421 23.375 15.4261 23.375H9.6672H5.98164C4.24297 23.375 2.8335 21.9479 2.8335 20.1875V15.4062C2.8335 9.24482 7.76665 4.25 13.852 4.25ZM12.0835 11.3333C12.0835 10.1827 13.0162 9.25 14.1668 9.25C15.3174 9.25 16.2502 10.1827 16.2502 11.3333C16.2502 12.4839 15.3174 13.4167 14.1668 13.4167C13.7526 13.4167 13.4168 13.7525 13.4168 14.1667C13.4168 14.5809 13.7526 14.9167 14.1668 14.9167C16.1459 14.9167 17.7502 13.3124 17.7502 11.3333C17.7502 9.35431 16.1459 7.75 14.1668 7.75C12.1878 7.75 10.5835 9.35431 10.5835 11.3333C10.5835 11.7475 10.9193 12.0833 11.3335 12.0833C11.7477 12.0833 12.0835 11.7475 12.0835 11.3333ZM15.5835 18.4167C15.5835 19.1991 14.9492 19.8333 14.1668 19.8333C13.3844 19.8333 12.7502 19.1991 12.7502 18.4167C12.7502 17.6343 13.3844 17 14.1668 17C14.9492 17 15.5835 17.6343 15.5835 18.4167ZM18.5742 29.7499C15.2997 29.7499 12.4144 28.0627 10.7201 25.5H15.4261C21.8405 25.5 26.9955 20.2423 26.9955 13.8125C26.9955 13.546 26.9867 13.2814 26.9692 13.019C29.5258 15.062 31.1667 18.2276 31.1667 21.7812V26.5624C31.1667 28.3228 29.7573 29.7499 28.0186 29.7499H18.5742Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01);
export default __webpack_public_path__ + "static/media/01.0c2c6d257b5f179afbb555846e6a75fa.svg";
export { ForwardRef as ReactComponent };